import React from 'react';

// Types
import { OnboardingFlowType } from './OnboardingWizard/types';

// Hooks
import { useOnboardingState } from 'Shared/utils/hooks/use-onboarding-state';

// Components
import Onboarding from './Onboarding';
import MagicOneOnOne from './MagicOneOnOne/MagicOneOnOne';
import CalendarIntegration2023 from './CalendarIntegration2023/CalendarIntegration2023';
import MarketingThirdPartyBrowswerSignup from './OnboardingWizard/MarketingThirdPartyBrowswerSignup/MarketingThirdPartyBrowswerSignup';

const OnboardingWrapper = () => {
  const { flowType, showInAppBrowserScreen } = useOnboardingState();

  if (showInAppBrowserScreen) return <MarketingThirdPartyBrowswerSignup />;

  if (flowType === OnboardingFlowType.magicOneOnOne || flowType === OnboardingFlowType.magicOneOnOneInvited)
    return <MagicOneOnOne />;
  if (
    flowType === OnboardingFlowType.calendarIntegration2023 ||
    flowType === OnboardingFlowType.calendarIntegration2023Invited
  )
    return <CalendarIntegration2023 />;
  return <Onboarding />;
};

export default OnboardingWrapper;
